import ba_logo from "../../img/logo/ba_logo_long.svg?url";
import ca_logo from "../../img/logo/ca_logo_long.svg?url";
const CA = window["CA"] || {};
export const config = {
  referenceUrl: CA.referenceUrl || "https://ref.cadamap.com",
  searchUrl: CA.searchUrl || "https://ref.cadamap.com",
  tileUrl: "https://tile.cadamap.com",
  site: CA.site,
  logo: CA.site?.prefix === "ba" ? ba_logo : ca_logo,
};
export const useConfig = () => config;
